import { PERMISSIONS } from '@/generated/permissions'

export const overtimeRoutes = [
  {
    component: () => import('@/domains/overtime/pages/AdminRequestsPage.vue'),
    meta: { anyPerm: [PERMISSIONS.OVERTIME_REVIEW], requiresAuth: true },
    name: 'admin-overtime-requests',
    path: '/admin/overtime-requests',
  },
]
